/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\SeenCar\SeenCar.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Thursday December 21st 2023
 * Author: Jonathan MAZAT
 * -----
 * Last Modified: Thursday December 21st 2023 3:32:47 pm
 * Modified By: the developer formerly known as Jonathan MAZAT at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import translator from "MultiLanguage/TranslationWrapper";
import Styles from "Content/SeenCar/SeenCar.module.css";
import { useEffect, useState } from "react";
import SeenCarService from "Services/SeenCar/SeenCar.service";
import { SeenCarType } from "./SeenCarRow/SeenCarRow";
import SeenCarModule from "./SeenCarModule/SeenCarModule";

type ViewsPageProps = {
    showTimeFilter: boolean,
    userID?: string,
    sellID?: string,
    order?: string,
    orderby?: string,
    page?: number,
    setOrderBy?: Function,
    setOrder?: Function,
}

function SeenCarComponent (props: ViewsPageProps) {
    const [myViews, setMyViews] = useState<SeenCarType[]>([]);
    const [myCount, setMyCount] = useState<number>(0);

    useEffect(() => {
        const requestToSend = {
            // from: props.orderby ?? "week",
            // per_page: props.page ? 50*props.page : 50,
            order: props.order ?? "desc",
            page: 1,
            userid: props.userID,
            sellid: props.sellID,
        };
        SeenCarService.getAllView(requestToSend).then((res: {count: number, seenCar: SeenCarType[]}) => {
            setMyViews(res.seenCar);
            setMyCount(res.count);
            const url = window.location;
            const searchParams = new URLSearchParams(url.search);
            searchParams.set("page", props.page ? props.page.toString() : "1");
            window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
        }).catch(err => {
            console.error(err);
        });
    }, [props.userID]);

    return (
        <div className={`${Styles.pageholder}`}>
            <h1>{translator.decode("stats.seenCars")}</h1>
            <SeenCarModule showTimeFilter={props.showTimeFilter} myViews={myViews} viewCount={myCount} userID={props.userID} order={props.order} orderby={props.orderby} setOrderBy={props.setOrderBy} setOrder={props.setOrder} sellID={props.sellID} />
        </div>
    )
}

export default SeenCarComponent;
